// @packages
import _ from 'lodash';
import { renderToString } from 'react-dom/server';

// @scripts
import {
    // getJQueryElement,
    keyCode,
    // onIgDataSourceFiltering,
    visibilityOfTooltips
} from './helpers';

export const handleOnCellFocus = (event) => {
    const { currentTarget } = event;
    window.setTimeout(() => currentTarget.select(), 100);
};

export const handleOnCellKeyDown = () => { };

export const handleOnCellKeyUp = () => { };

export const handleOnCheckItemChanged = ({
    dataSource,
    onCheckItemChanged,
    primaryKey,
    ui
}) => {
    const isChecked = ui.state === 'on';
    const ids = ui.isHeader
        ? Array.from(ui.grid.rows()).map((row) => row.getAttribute('data-id'))
        : [ui.rowKey];
    const items = dataSource.filter((item) => ids.some((id) => item[primaryKey] === id));
    onCheckItemChanged({ items, isChecked });
};

export const handleOnColumnMoving = ({ onColumnMoving }) => {
    if (onColumnMoving) {
        onColumnMoving();
    }
};

export const handleOnColumnSorting = ({ onColumnSorting }) => {
    if (onColumnSorting) {
        onColumnSorting();
    }
};

export const handleOnColumnSorted = ({ ui }) => {
    if (ui.expressions.length > 0) {
        const inx = _.findLastIndex(ui.expressions);
        const fName = ui.expressions[inx].fieldName;
        const expr = ui.expressions[inx].dir;
        ui.owner.clearSorting();
        ui.owner.sortColumn(fName, expr);
    }
};

export const handleOnCommit = ({
    columns,
    jQueryGrid,
    onEditCellEnded,
    primaryKey
}) => {
    jQueryGrid.igGridUpdating('endEdit', true);
    const item = global.editingItem;
    const rows = Array.from(jQueryGrid.igGrid('allRows'));
    const row = rows.find((row) => row.dataset.id === item[primaryKey]);
    const rowIndex = rows.indexOf(row);
    const editableColumns = columns.filter((column) => !column.readOnly);
    editableColumns.forEach((column) => {
        item[column.key] = jQueryGrid.igGrid(
            'cellAt',
            columns.indexOf(column), rowIndex
        ).innerText.trim();
    });
    onEditCellEnded(item, rowIndex);
};

export const handleOnDataFiltered = ({ onDataFiltered }) => {
    if (onDataFiltered) {
        onDataFiltered();
    }
};

export const handleOnDataFiltering = ({ columns, onDataFiltering, ui }) => {

    // getJQueryElement(ui.owner.element).data('igGrid')
    //     .dataSource.settings.filtering.customFunc = (fieldExpressions, dataSource) => onIgDataSourceFiltering({
    //         columns,
    //         dataSource,
    //         fieldExpressions
    //     });

    if (onDataFiltering) {
        onDataFiltering();
    }
};

export const handleOnEditCellEnded = ({
    onEditCellEnded, row
}, rowIndex) => {
    if (onEditCellEnded) {
        onEditCellEnded(row, rowIndex);
    }
};

export const handleOnEditCellStarting = ({
    event,
    getItemById,
    onEditCellStarting,
    ui
}) => {
    visibilityOfTooltips('hidden');
    const item = getItemById(ui.rowID);
    const isCellDisabled = item && item.disabledColumns && item.disabledColumns.some(ui.columnKey);
    const isElementDisabled = event.toElement && event.toElement.hasAttribute('disabled');
    const isTabOrEnterKey = [keyCode.TAB, keyCode.ENTER].some((item) => item === event.keyCode);
    const disableEditing = isTabOrEnterKey || isElementDisabled || isCellDisabled;

    if ((isCellDisabled || (item && item.isRowDisabled))
        && (item.disabledMessage && (!event.keyCode || (event.keyCode && item.DisabledMessageWhileNavigating)))) {
        // eslint-disable-next-line no-alert
        alert(item.disabledMessage);
    }

    if (onEditCellStarting && !disableEditing) {
        onEditCellStarting();
    }

    global.editingItem = item;
    return !disableEditing;
};

export const handleOnHeaderCellRendered = ({ headerLabels, ui }) => {
    const { headerText, key } = ui.owner.columnByKey(ui.columnKey);
    const text = headerText !== key ? headerText : headerLabels[ui.columnKey] || ui.columnKey;
    ui.th.text(text);
};

export const handleOnRowPanelRendered = ({
    classes,
    columns,
    dataSource,
    primaryKey,
    ui
}) => {
    const id = ui.owner.tmpDataSource[0];
    const item = dataSource.find((item) => item[primaryKey] === id);
    const column = columns.find((column) => column.key === 'rowPanelRendered');
    const html = renderToString(column.rowPanelRender(item));
    const element = ui.tbody.context.getElementsByTagName('div')[0];
    element.classList.add(classes.rowPanel);
    element.innerHTML = html;
};

export const handleOnRowsRendered = ({
    checkedItems,
    jQueryGrid,
    ui,
    primaryKey
}) => {
    const rows = Array.from(ui.owner.rows());
    const selectRow = (index) => jQueryGrid.igGridSelection('selectRow', index);
    rows.forEach((row, index) => {
        const cells = Array.from(row.cells);

        cells.forEach((cell) => {
            const isEditable = cell.getAttribute('aria-readonly') === 'false';

            if (isEditable) {
                cell.addEventListener('click', (e) => e.target.click());
            }
        });

        if (checkedItems.some((item) => item[primaryKey] === row.getAttribute('data-id'))) {
            selectRow(index);
        }
    });
};

export const handleOnTooltipShowing = ({ onTooltipShowing, ui }) => {
    ui.tooltip = null;
    ui.tooltip = ui.element.innerText;
    let isOverFlow = ui.element.offsetWidth >= ui.element.scrollWidth;
    let visiblitiy = (isOverFlow || ui.element.classList.contains('ui-iggrid-editingcell')) ? '' : '';
    if (ui.columnKey == 'warningMessages') {
        ui.tooltip = (ui.value).join("<br />");
    }
    if (ui.element.innerText == 'ADD') {
        visiblitiy = 'hidden';
    }
    // const visiblitiy = (isOverFlow || ui.element.classList.contains('ui-iggrid-editingcell')) ? 'hidden' : '';
    visibilityOfTooltips(visiblitiy);

    if (onTooltipShowing) {
        onTooltipShowing();
    }
};
